import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IAttributes, IAugmentedJQuery, IModule, ISCEService, ITimeoutService} from "angular";
import {WebNavigasjon} from "web/tjenester/WebNavigasjon";
import {AutoTagType} from "felles/direktiver/ckeditor";
import {HtmlFormatertKontroller} from "../../../felles/komponenter/htmlFormatert/htmlFormatert";

/**
 * Viser html-formatert innhold, tilpasset web.
 */
    export class WebHtmlFormatertKontroller extends HtmlFormatertKontroller {
        static registrerKomponent(angular: IModule) {
            angular
                .component('wmHtmlFormatert', {
                    bindings: {
                        innhold: '<',
                        begrensetHoyde: '<'
                    },
                    controller: WebHtmlFormatertKontroller.forInjisering(),
                    template: require('felles/komponenter/htmlFormatert/htmlFormatert.html'),
                    transclude: true
                });
        }

        static forInjisering() {
            return [WebNavigasjon.regNavn, regNavn.ng.$element, regNavn.ng.$attrs, regNavn.ng.$timeout, regNavn.ng.$sce, WebHtmlFormatertKontroller]
        }

        constructor(private navigasjon:WebNavigasjon, $element:IAugmentedJQuery, $attrs:IAttributes, $timeout:ITimeoutService, $sce: ISCEService) {
            super($element, $attrs, $timeout, $sce);
        }

        håndterLenke(url: string) {
            window.open(url);
        }

        håndterAutoTagLenke(type: AutoTagType, id: string) {
            console.log('WEB håndterAutoTagLenke', type, id);
            switch(type) {
                case AutoTagType.dokument:
                    console.log('håndterAutoTagLenke DOK', id);
                    this.navigasjon.gåTilSakEllerArkivKnyttetTilDokumentVersjon(id);
                    /*const filnavn = this.kilde.pdfFilnavn ? this.kilde.pdfFilnavn : this.kilde.filnavn;
                                      const mimetype = this.kilde.pdfFilnavn ? this.filer.mimetyper.pdf.mimetype : this.kilde.originalformat;
                                      const url = this.dokumentRessurs.dokumentUrl(entitetId, mimetype, filnavn);
                                      window.open(url, "_blank");*/
                    return;
                /*case 'Medlem':
                    this.webnavigasjon.gåTilMedlem(this.kilde.gruppe, entitetId);
                    return;*/
                case AutoTagType.sak:
                    console.log('håndterAutoTagLenke SAK', id);
                    this.navigasjon.gåTilSak(id);
                    return;
                /*case 'Beslutning':
                    this.webnavigasjon.gåTilBeslutning2(this.kilde.møteId, this.kilde.sakId, entitetId);
                    return;*/
                default:
                    //this.webnavigasjon.gåTilEntitetRef({id: entitetId, type: this.treff._type.toLowerCase()});
                    return;
            }

        }

    }
